

module.exports = __webpack_require__.stylable.create(
    "Sort770459381",
    {"classes":{"root":"Sort770459381__root","sort":"Sort770459381__sort"},"vars":{},"stVars":{"textColor":"'\"color(--gallery_sortingFiltersTextColor)\"'","borderColor":"'\"color(--gallery_sortingFiltersTextColor)\"'","baseBGColor":"'\"fallback(color(--gallery_sortingFiltersColorBackground), color(color-1))\"'","font":"'\"font(--gallery_sortingFiltersTextFont)\"'","fontSize":"'\"unit(16, px)\"'","selectedBGColorOnHover":"'\"opacity(color(fallback(--gallery_sortingFiltersTextColor, color-5)), 0.06)\"'"},"keyframes":{}},
    "",
    14,
    "Sort770459381",
    null
);
